<template>
  <main class="mx-auto mb-5 pb-5 mb-md-0 pb-md-0">
    <div class="container-fluid skin-body">
      <div class="row">
        <router-view></router-view>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { app } from "@/guiide/ts/app";
const isAnon = true;
app.initialise(isAnon);
</script>

<style>
h2 {
  line-height: 1.2;
  margin-bottom: 16px;
}

.table th {
  font-size: 14px;
}
</style>
